<script>
import { SysVars } from "../main";
import {
  formatDate,
  formatDataHora,
  formatValue,
  isValidHashColor
} from "../shared/utils";
import {
  apiORDS,
  apiORDSpost,
  apiDownloadPDF,
  apiEmailPDF,
  apiORDSmidia
} from "../shared/api-functions";
import VarejoBarTop from "../components/varejo-bar-top";
import CustomerForm from "../forms/customer-form";
import VarejoAddItem from "./varejo-add-item";
import VarejoModalOpcoes from "./varejo-modal-opcoes";
import VarejoPagForm from "./varejo-pag-form";
import VarejoVaberturaForm from "./varejo-vabertura-form";
import VarejoVmCaixaForm from "./varejo-vmcaixa-form";
import VarejoEmissaoCupom from "./varejo-emissao-cupom";
import VarejoModalItemSequencia from "./varejo-modal-item-sequencia";
import VarejoModalNfce from "./varejo-modal-nfce";

import currentDateHour from "../components/current-date-hour";
import VarejoModalCliente from "./varejo-modal-cliente";
import VarejoModalVendas from "./varejo-modal-vendas.vue";

import apiPedido from "../api/api-pedido.js";

import autorizaNFe from "../api/api-nfe.js";
import { VueOfflineMixin } from "vue-offline";

import CpfValidate from "../shared/cpf";
import MdMessage from "../components/md-message.vue";
import SidebarComandas from "../components/sidebar-comandas.vue";
import ProdutosDestaques from "../components/produtos-destaques.vue";
import VarejoQuantidadeItem from "./varejo-quantidade-item.vue";
import VarejoModalObs from "./varejo-modal-obs.vue";
import VarejoModalCaixa from "./varejo-modal-caixa.vue";
import VarejoModalPendcli from "./varejo-modal-pendcli.vue";

//ALGUMAS CONFIGURACOES E PERMISSOES DO OPERADOR DO CAIXA
//DEFINIR A CARGA DESTAS INFORMACOES AO INICIAR A TELA DE FRENTE DE CAIXA
const PARAMS_CAIXA = {
  nome: "", //nome do operador
  codfil: "1",
  permissoes: {
    qtparcelas: 12,
    alterapreco: true,
    cadastraprodutovenda: true,
    pdescontoitem: 10,
    pdescontovenda: 10,
    descontonavenda: true,
    descontonoitem: true,
    abrefechacaixa: true,
    cancelavenda: true,
    cancelaitem: true,
    recebecheque: true,
    sangria: true,
    valorsangria: 100
  },
  caixa: {
    codcaixa: 1, //codigo do caixa selecionado na abertura do caixa (tabela VCAIXA)
    descricao: "",
    agrupaprodutos: true,
    permitevendaespera: true,
    permitefiado: true,
    imprimedesconto: true,
    vendasimples: true,
    tokensat: "",
    senhasat: "",
    codmcaixa: 0, //CODIGO DO MOVIMENTO DE ABERTURA DO CAIXA (TABELA VMCAIXA)
    databerturacaixa: "",
    valoraberturacaixa: 0
  },
  tpag: {
    //TIPOS CORRESPONDENTES AO CAMPO FPAG.FORMAPAG
    dinheiro: "01",
    cheque: "02",
    credito: "03",
    debito: "04",
    creditoloja: "05",
    alimentacao: "10",
    refeicao: "11",
    presente: "12",
    combustivel: "13",
    boleto: "15",
    outros: "99"
  },
  listaFavoritos: [], //LISTA DE PRODUTOS FAVORITOS
  selectedItem: {}
};

export default {
  props: {
  },

  components: {
    VarejoAddItem,
    VarejoPagForm,
    VarejoModalOpcoes,
    CustomerForm,
    VarejoVmCaixaForm,
    VarejoVaberturaForm,
    VarejoBarTop,
    VarejoEmissaoCupom,
    MdMessage,
    currentDateHour,
    SidebarComandas,
    VarejoModalItemSequencia,
    VarejoModalNfce,
    VarejoModalPendcli,
    ProdutosDestaques,
    VarejoModalCliente,
    VarejoQuantidadeItem,
    VarejoModalObs,
    VarejoModalVendas,
    VarejoModalCaixa,
    isValidHashColor
  },

  mixins: [apiPedido, VueOfflineMixin, autorizaNFe],

  data() {
    return {
      index: null,
      runningItemRequest: false,
      filaRequicaoItens: [],
      showModalObs: "",
      windowListener: "",
      comandas: "",
      showModalMesa: false,
      showModalComanda: false,
      codmesa: "",
      mesaobs: "",
      codcomanda: "",
      windowHeight: "",
      inFocus: false,
      showFullScreenRequest: true,
      selectedMesa: false,
      deletarCliente: false,

      showMesaObs: false,

      showModalnfce: false,

      shortcuts: "",
      crud: "",
      crudText: "",
      listSequence: 0, //Exibe sequencia na lista de itens
      view: false, //variavel para controle de visualizacao ou edicao
      modoView: false,
      formItemsPedido: true, //exibe a lista de itens
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showTotal: false,
      showModalDesconto: false,
      showModalAcrescimo: false,
      CANCEL_MESSAGE: false,
      SHOW_CONFIRMADMINPASS: false,
      adminPass: "",
      isValidCabec: true,

      //entidades
      filial: {},
      params_pdv: {},
      savedOrder: null,
      pedv: [{ ...this.$store.getters.getEntities.pedv }],
      pedvit: [],
      pedvpar: [], //parcelas do pedido
      vmovcaixa: {},
      pedvit_update: {},
      pedvit_beforeUpdate: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {}, //armazena as mensagens de validacao do pedido de venda apos a gravacao
      params_confirmAdminPass: "",
      item_editing: false,
      showModalCliente: false,
      pedvit_index: "",
      listaComandas: [],

      moreActions: [], //botao mais acoes

      vabertura: null,

      showPagamentoVenda: false,
      showVAbertura: false,
      showVmovCaixaForm: false,
      showEmissaoCupom: false,
      showEmissaoCupomVmov: false,

      paramsPagamento: {},
      paramsvmovcaixa: {},

      unwatch: true,

      selectedItem: {}, //item selecionado na pesquisa
      coditem: "",

      editItemValue: null, // valor do item modal
      showModalEditItem: false,
      errMessageModalEditItem: "",
      modalCrud: "",
      messageCallModal: "",

      showViewItem: false,
      itemView: [],

      codpart: null,
      selectedPart: null,

      action: "",
      finalizaVendaAction: null,

      urlimage: this.$store.getters.urlApp + "logo/download/6/1",

      showSidebar: false,
      showDestaques: false,

      pdesc: 0,
      vlrdesc: 0,
      pdesp: 0,
      vlrdesp: "",
      watching: "",

      showModalQtd: false,
      showVendas: false,
      showCaixa: false,
      showModalPendcli: false,

      qtdItemInformada: 0,
      vlrItemInformado: 0,
      showModalMaisAcoes: false,
      vendaManual: false,
      item_waiting: false,
      informed_qt: false,
      cx_code: null,
      caixa: null,
    };
  },

  computed: {
    listMesas: function () {
      let mesas = [];
      if (this.params_pdv.listMesas) {
        mesas = this.params_pdv.listMesas;
      } else {
        mesas.push({ descricao: null, id: null, obs: null });
      }
      if (!mesas.hasOwnProperty("pedidos")) {
        mesas.pedidos = [{}];
      }
      return mesas;
    },
    closeCaixa: function () {
      return this.showCaixa;
    },
    hasComandaControl: function () {
      return this.params_pdv.tipo_controle_cm_ms == "CM";
    },
    hasMesaControl: function () {
      return this.params_pdv.tipo_controle_cm_ms == "MS";
    },
    hasMesaComandaControl: function () {
      return this.params_pdv.tipo_controle_cm_ms == "MC";
    },
    logoStyle: function () {
      if (!this.pedv || this.pedvit < 5 || this.pedv.pedvit < 5) {
        return "opacity: 20%; position:absolute; top:200px;";
      } else {
        return "opacity:8%; position:absolute; top:200px;";
      }
    },
    usuarionome: function () {
      return this.$store.getters.getEnv.usuarionome;
    },

    isEmpty: function () {
      if (jQuery.isEmptyObject(this.pedv)) {
        return true;
      } else {
        return !this.pedv.data;
      }
    },

    isView: function () {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      return (
        this.view ||
        (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") ||
        this.pedv.fin_baixado > 0 ||
        this.pedv.fin_remessa > 0 ||
        this.pedv.nf_emitida > 0 ||
        this.pedv.nf_pendente > 0
      );
    },

    listaItensPreferencias: function () {
      return this.$store.getters.getItemSalesList;
    },

    part: function () {
      if (this.$store.getters.getPart.length > 0) {
        return this.$store.getters.getPart[0];
      } else {
        return null;
      }
    },
    currentDate: function () {
      let data = new Date();
      return data;
    },

    disableTppedv: function () {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === "P" && this.pedv.codpedv != null;
    },

    _cnpjcpf: function () {
      //FORMATACAO DO CNPJ DO CLIENTE
      let doc = "";
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf;
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc);
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc);
      }
      return doc;
    },

    alterapreco: function () {
      return this.params_pdv.altera_preco;
    },
    btnCustomStyle: function () {
      return `font-size:${5}px`;
    }
  },

  filters: {
    format: function (value, decimals) {
      return formatValue(value, decimals);
    },
    formatDataHora(value) {
      return formatDataHora(value);
    },

    formatDate: function (value) {
      return formatDate(value);
    }
  },

  methods: {
    focusItem() {
      let self = this
      self.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
        if (self.$refs.item)
          self.$refs.item.focus();
      });
      self.inFocus = false;
    },
    handleConfig() {
      this.showModalMaisAcoes = !this.showModalMaisAcoes;
    },
    handleSelectedOption(selected) {
      //RETORNO DO BOTAO MAIS OPCOES
      if (selected == 'fecharcaixa' || selected == 'sangrar' || selected == 'reforcar') {
        if (this.isVendaAberta()) {
          this.$erpToastWarning('Finalize a venda em andamento')
          return
        }
      }

      this.showModalMaisAcoes = false
      if (selected == 'fecharcaixa')
        this.handleFecharCaixa();
      else
        if (selected == 'sangrar')
          this.showConfirmAdminPass(this.handlerSangrar);
        else
          if (selected == 'reforcar')
            this.showConfirmAdminPass(this.handlerReforcar);
          else
            if (selected == 'excluir')
              this.handleShowModalEditItem('delete');
            else
              if (selected == 'mesacomanda')
                // params_pdv.tipo_controle_cm_ms == "CM" || params_pdv.tipo_controle_cm_ms == "MC"
                this.handleShowModalMesaComanda()
              else
                if (selected == 'destaques')
                  this.handleShowDestaques()
                else
                  if (selected == 'pendcli')
                    this.handleShowPendcli()
    },

    handleShowPendcli() {
      this.showModalPendcli = true
    },

    handleInformaMesa({ obs, mesa }) {
      this.closeModalObs();
      this.handleCloseComandas();
      this.novavenda();
      this.pedv.obspedido = obs;
      this.pedv.mesa = mesa;
    },
    handleShowMesaComanda(codmesa) {
      this.pedv.mesa = codmesa;
      if (this.hasMesaControl) {
        this.handleShowModalObs();
      } else {
        this.handleShowModalComanda();
      }
    },
    handlePdesp(newValue) {
      this.vlrdesp = 0;

      if (!this.watching) {
        this.watching = "P";
      }
      if (newValue && this.watching == "P") {
        this.vlrdesp = (newValue * this.pedv.totmer) / 100;
      } else {
        this.vlrdesp = 0;
      }

      this.watching = "";
    },
    handleVlrdesp(newValue) {
      this.pdesp = 0;

      if (!this.watching) {
        this.watching = "V";
      }

      if (newValue && this.watching == "V") {
        let lAux = this.pedv.totmer;

        lAux = ((newValue ? newValue : 0) * 100) / lAux;

        this.pdesp = Math.round((lAux + Number.EPSILON) * 100) / 100;
      }

      this.watching = "";
    },
    handlePdesc(newValue) {
      this.vlrdesc = 0;

      if (!this.watching) {
        this.watching = "P";
      }
      if (newValue && this.watching == "P") {
        this.vlrdesc = (newValue * this.pedv.totmer) / 100;
      } else {
        this.vlrdesc = 0;
      }

      this.watching = "";
    },
    handleVlrDesc(newValue) {
      this.pdesc = 0;

      if (!this.watching) {
        this.watching = "V";
      }

      if (newValue && this.watching == "V") {
        let lAux = this.pedv.totmer;

        lAux = ((newValue ? newValue : 0) * 100) / lAux;

        this.pdesc = Math.round((lAux + Number.EPSILON) * 100) / 100;
      }

      this.watching = "";
    },
    async loadAbertura() {
      //efetua a abertura do caixa
      let codcaixa = null;
      let caixaaberto = false;
      await apiORDS(this.$store.getters.urlOrds + 'varejo/caixas', null, true).then((result) => {
        if (result.items.length == 1) {
          if (result.items[0].uuid != this.$store.getters.getEnv.uuid) {
            return
          }
          codcaixa = result.items[0].codvcaixa;
          caixaaberto = result.items[0].caixaaberto == 'S';
          this.vabertura = result.items[0];
        }
      });
      if (!caixaaberto) {
        this.handleAberturaCaixa()
      }
    },

    async loadFilial() {
      await apiORDS(
        this.$store.getters.urlOrds + "cg/filial/varejo",
        null,
        true
      ).then(result => {
        if (result.items.length > 0) {
          this.filial = result.items[0];
          this.handleParamPDV();
          this.loadLogoTipo();
        }
      });
    },
    closeModalObs() {
      this.showModalObs = false;
      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });
    },
    handleShowModalObs() {
      this.showModalObs = true;
    },
    closeModalQtd() {
      this.showModalQtd = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    handleShowModalQtd() {
      this.showModalQtd = true;
    },
    closeModalPendcli() {
      this.showModalPendcli = false
    },

    handleChangeCodPart(value) {
      if (!value) {
        this.selectedPart = null
        this.codpart = null
      }
      else {
        this.selectedPart = {}
        this.selectedPart.codpart = value;
        this.codpart = value;
      }
      this.carregaDadosCliente();

      if (!this.showPagamentoVenda) {
        this.$nextTick(function () {
          this.$refs.item.focus();
        });
      }
    },
    async loadMesaComanda() {
      let param = {};
      param.query = "";

      if (this.hasMesaControl || this.hasMesaComandaControl) {
        this.listMesas.forEach(async (mesa, ind) => {
          param.query = "mesa=" + mesa.id + "&";

          await this.$store.dispatch("loadPedvList", param);

          mesa.pedidos = [...this.$store.getters.getPedvList];

          for (let index = 0; index < mesa.pedidos.length; index++) {
            const ped = mesa.pedidos[index];

            if (
              this.hasMesaComandaControl &&
              (ped.comanda == null || ped.comanda == "" || !ped.comanda)
            ) {
              mesa.pedidos.splice(index, 1);
              index--;
            } else if (this.hasMesaControl && ped.comanda) {
              mesa.pedidos.splice(index, 1);
              index--;
            } else if (ped.stpedv != "D") {
              mesa.pedidos.splice(index, 1);
              index--;
            }
          }
        });
        return;
      }

      if (this.hasComandaControl) {
        let param = {};
        param.query = "";

        param.query = "comanda=" + "-1" + "&";

        await this.$store.dispatch("loadPedvList", param);

        let comandas = [];
        this.listaComandas = [];
        this.$store.getters.getPedvList.forEach((comanda, index) => {
          if (comanda.stpedv == "D" && !comanda.mesa) {
            comandas.push({
              codpedv: comanda.codpedv,
              comanda: comanda.comanda,
              stpedv: comanda.stpedv,
              data: comanda.data
            });
          } else {
            return;
          }
        });

        this.listaComandas = comandas;
        return;
      }
    },
    handleCancelInput(index) {
      this.$set(this.params_pdv.listMesas[index], "showObs", false);
      this.mesaobs = "";
      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
    },
    handleChangeMesa(index) {
      let mesaIndex = "";
      if (index || index == 0) {
        mesaIndex = index;
        this.codmesa = this.params_pdv.listMesas[mesaIndex].id;
      } else {
        this.params_pdv.listMesas.find((e, i) => {
          if (e.id == this.codmesa) {
            mesaIndex = i;
          }
        });
      }

      this.$set(this.params_pdv.listMesas[mesaIndex], "showObs", true);

      if (this.hasMesaComandaControl) {
        this.$nextTick(function () {
          this.$refs.confirmMesaBtn.focus();
        });
      }

      var self = this;
      if (this.params_pdv.listMesas[mesaIndex].showObs) {
        self.$nextTick(function () {
          self.$refs.mesaobs[0].focus();
        });
      }
    },
    handleInformaComanda() {
      this.showModalComanda = false;
      if (!this.codcomanda) {
        this.$erpToastError("Campo o obrigatorio");
        return;
      }

      this.novavenda();

      this.pedv.mesa = this.codmesa;
      this.pedv.comanda = this.codcomanda;

      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
      this.handleCloseComandas();
    },
    handleCloseModalComanda() {
      this.showModalComanda = false;
      this.codcomanda = "";

      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });

      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },
    handleShowModalComanda() {
      this.showModalComanda = true;

      this.$nextTick(function () {
        this.$refs.comandaid.focus();
      });
    },
    handleCloseModalMesa() {
      this.showModalMesa = false;
      this.codmesa = "";
      this.mesaobs = "";

      this.listMesas.forEach(mesa => {
        mesa.showObs = false;
      });

      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });

      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },

    handleShowModalMesa() {
      this.loadMesaComanda();
      this.showModalMesa = true;
      this.codmesa = "";
      this.mesaobs = "";

      this.listMesas.forEach(mesa => {
        if (mesa.showObs) mesa.showObs = false;
      });

      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
    },

    handleModalCliente(deletar) {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (deletar) {
        this.deletarCliente = deletar;
      }
      this.showModalCliente = true;
    },

    closeModalCliente() {
      this.showModalCliente = false;

      if (this.showPagamentoVenda) {
        if (document.getElementById("btnPaymentDone"))
          document.getElementById("btnPaymentDone").focus()
        else
          if (document.getElementById("paymentType"))
            document.getElementById("paymentType").focus()
      } else
        this.focusItem()
    },

    closeModalDescontoAcrescimo() {
      if (this.showModalAcrescimo) {
        this.showModalAcrescimo = false;
      }
      if (this.showModalDesconto) {
        this.showModalDesconto = false;
      }
    },
    async loadLogoTipo() {
      let self = this;

      await apiORDSmidia(
        this.$store.getters.urlApp +
        "logo/download/" +
        this.filial.codempresa +
        "/" +
        this.filial.codfil
      ).then(data => {
        if (data && data.size > 0) {
          let reader = new window.FileReader();
          reader.readAsDataURL(data);
          reader.onload = function () {
            self.$set(self.filial, "urlimage", reader.result);
          };
        }
      });
    },
    showModalViewItem(itemssearch) {
      this.showViewItem = true;
      if (this.$refs.btnClose) {
        this.$nextTick(() => {
          this.$refs.btnClose.focus();
        });
      }

      if (itemssearch[0]) {
        this.itemView = itemssearch[0];
        return;
      } else {
        this.itemView = itemssearch;
      }
    },
    handleViewItem() {
      if (!this.showViewItem) {
        return;
      }

      this.showViewItem = false;

      this.$nextTick(() => {
        this.$refs.item.focus();
      });
    },

    handleInputModalEditIt() {
      if (!this.showModalEditItem) return;

      if (this.editItemValue > this.pedvit.length) {
        if (this.editItemValue == null || this.editItemValue == 0) {
          return (this.errmessages = "");
        } else {
          this.errMessageModalEditItem = "Valor não permitido";
        }
      } else {
        this.errMessageModalEditItem = "";
      }
    },
    closeModalEditItem() {
      if (this.showModalEditItem) this.showModalEditItem = false;
      this.editItemValue = null;
      this.modalCrud = null;
      this.$nextTick(() => {
        this.$refs.item.focus();
      });
    },
    handleShowModalEditItem(crud) {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (this.runningItemRequest || this.filaRequicaoItens.length > 0) {
        this.$erpToastError(
          "Não foi possivel realizar Aguarde até que todos os intens sejam inseridos"
        );
        return;
      }
      this.showModalEditItem = true;
      this.modalCrud = crud;
    },
    handlerSangrar() {
      this.handleVmovCaixaForm("S");
    },
    handlerReforcar() {
      this.handleVmovCaixaForm("E");
    },
    confirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.params_confirmAdminPass();
    },
    showConfirmAdminPass(params) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = params;
    },
    hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    async handleShowModalMesaComanda() {
      if (!this.params_pdv.tipo_controle_cm_ms) {
        this.$erpToastError(
          "Habilite o parâmetro para controle de mesas ou comandas"
        );
        return;
      }
      await this.loadMesaComanda();
      this.showSidebar = true;
    },
    handleCloseComandas() {
      this.showSidebar = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },

    handleFecharCaixa() {
      if (this.showCaixa) {
        this.showCaixa = false;
      } else {
        this.showCaixa = true;
      }
      // this.$router.push(`/varejo/controlecaixa/${this.vabertura.codvabertura}`);
      // let body = document.querySelector("body");
      // body.style.overflow = "auto";
    },

    handleClosePDV() {
      this.$router.push("/varejolist");
    },

    getAction(action) {
      //executa a acao dos botoes do menu
      this.action = action;
    },

    handleParamPDV() {
      if (this.filial && this.filial.parametros_pdv) {
        this.params_pdv = JSON.parse(this.filial.parametros_pdv);
        this.vendaManual = this.params_pdv.formato_venda_manual == 'S'
        this.loadMesaComanda();
      } else {
        this.params_pdv = { ...this.$store.getters.getParamPDV }
      }
    },

    calculaPercentualAcrescimo() {
      this.pedv.pdesp_aux = 0;
      this.pedv.vlrdesp_aux = 0;
      this.pedv.pdesp = 0;
      if (this.pedv.totmer > 0) {
        let lAux = (this.pedv.vlrdesp * 100) / this.pedv.totmer;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedv.pdesp = lAux;
        this.pdesp = lAux;
      }
    },

    calculaPercentualDesconto() {
      this.pedv.pdesc_aux = 0;
      this.pedv.vlrdesc_aux = 0;
      this.pedv.pdesc = 0;
      if (this.pedv.totmer > 0) {
        let lAux = (this.pedv.vlrdesc * 100) / this.pedv.totmer;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedv.pdesc = lAux;
        this.pdesc = lAux;
      }
    },

    handleInformarDesconto() {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }

      if (this.params_pdv.permite_desconto != 'S' && this.params_pdv.permite_acrescimo != 'S') {
        this.$erpToastWarning("Não é permitido");
        return;
      }

      this.vlrdesc = this.pedv.vlrdesc
      this.vlrdesp = this.pedv.vlrdesp

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();

      if (this.showModalDesconto) {
        this.showModalDesconto = false;
      } else {
        this.showModalDesconto = true;

        this.$nextTick(function () {
          this.$refs.desconto.focus();
        });
      }
    },

    handleDesconto() {
      // Desconto
      this.pedv.pdesc_aux = this.pdesc;
      this.pedv.vlrdesc_aux = this.vlrdesc;

      console.log(parseFloat(this.params_pdv.desconto_max))
      console.log(parseFloat(this.pedv.pdesc_aux))

      if (this.params_pdv.desconto_max) {
        if (parseFloat(this.pedv.pdesc_aux) > parseFloat(this.params_pdv.desconto_max)) {
          this.showModalDesconto = true;
          this.$erpToastError("Desconto maior que o máximo permitido (" +
            this.params_pdv.desconto_max + ")!");
          return;
        }
      }

      this.pedv.vlrdesc = Number(Math.round(this.pedv.vlrdesc_aux * 100) / 100);
      this.pedv.pdesc = Math.round((this.pedv.pdesc_aux + Number.EPSILON) * 100) / 100;

      // Acrescimo

      this.pedv.pdesp_aux = this.pdesp;
      this.pedv.vlrdesp_aux = this.vlrdesp;

      if (this.pedv.pdesp_aux > this.params_pdv.acrescimo_max) {
        this.$erpToastError("Acrescimo maior que o máximo permitido (" + this.params_pdv.acrescimo_max + "%)! ");
        return;
      }

      this.pedv.vlrdesp = Number(Math.round(this.pedv.vlrdesp_aux * 100) / 100);
      this.pedv.pdesp = Math.round((this.pedv.pdesp_aux + Number.EPSILON) * 100) / 100;

      this.showModalDesconto = false

      this.pedv.totger =
        this.pedv.totmer +
        (this.pedv.vlrdesp ? this.pedv.vlrdesp : 0) -
        (this.pedv.vlrdesc ? this.pedv.vlrdesc : 0);

      if (this.showPagamentoVenda) {
        this.paramsPagamento.totalVenda = this.pedv.totger
        this.$refs.pagamentoVenda.handleLimparPag()
      }
      else
        this.focusItem()

      //DISPARA O TIMER PARA GRAVACAO DO PEDIDO
      let vm = this;
      if (this.apiTimer) {
        clearTimeout(this.apiTimer);
      }
      this.apiTimer = setTimeout(function () {
        vm.gravaItem(false, false);
      }, 1000);

    },

    calculaItem(novoitem) {
      this.pedv.totmer = 0;
      this.pedv.totger = 0;

      for (var x = 0; x < this.pedvit.length; x++) {
        let lAux = 0.0;
        lAux = this.pedvit[x].qtuni * this.pedvit[x].vlr;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedvit[x].totbru = lAux;

        lAux =
          lAux *
          ((100 - (this.pedvit[x].pdesc1 ? this.pedvit[x].pdesc1 : 0)) / 100);

        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedvit[x].totliq = lAux;

        this.pedvit[x].totdes = this.pedvit[x].totbru - this.pedvit[x].totliq;

        this.pedv.totmer = this.pedv.totmer + this.pedvit[x].totbru;
        this.pedv.totger = this.pedv.totger + this.pedvit[x].totliq;
      }

      this.pedv.totger =
        this.pedv.totger +
        (this.pedv.vlrdesp ? this.pedv.vlrdesp : 0) -
        (this.pedv.vlrdesc ? this.pedv.vlrdesc : 0);

      this.pedv.totdes = this.pedv.totger - this.pedv.totmer - this.pedv.vlrdesp;

      if (novoitem) {
        //ao incluir novo produto, zera o desconto ou acrescimo informado no total da venda
        this.pedv.pdesc = 0
        this.pedv.pdesp = 0
        this.pedv.vlrdesc = 0
        this.pedv.vlrdesp = 0
        this.vlrdesc = 0
        this.vlrdesp = 0
        this.pdesc = 0
        this.pdesp = 0
      }

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();
    },

    statusColor: function (value) {
      let color = "badge-green";
      if (value == "C") {
        color = "badge-red";
      } else if (value == "D") {
        color = "badge-orange";
      }
      return color;
    },

    closeForm() {
      if (this.$route.params && this.$route.params.novo) {
        this.$router.push("/pedidolist");
        let body = document.querySelector("body");
        body.style.overflow = "auto";
      } else {
        this.$emit("closeform");
      }
    },

    closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      if (id) this.pedv.codpart = id;
      this.showPartForm = false;
    },

    closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false;
    },

    handleNewItem(selectedItem) {
      //AO SELECIONAR UM ITEM NA PESQUISA, ADICIONA O ITEM NA VENDA
      if (!selectedItem) {
        return;
      }
      if (this.isEmpty) {
        this.handleNovaVenda();
      }
      if (
        (this.hasMesaComandaControl || this.hasMesaControl) &&
        !this.pedv.mesa &&
        !this.pedv.codpedv
      ) {
        this.handleNovaVenda();
        return;
      }
      if (this.hasComandaControl && !this.pedv.comanda && !this.pedv.codpedv) {
        this.handleNovaVenda();
        return;
      }

      if (this.qtdItemInformada) {
        selectedItem.quantidade = this.qtdItemInformada;
      }

      if (this.vlrItemInformado) {
        selectedItem.vlrtab = this.vlrItemInformado;
      }

      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") {
        return;
      }

      if (!selectedItem.vlrtab) {
        selectedItem = {};
        this.selectedItem = {};
        this.$erpToastError("Não é possivel inserir itens com valor zerado. Verificar tabela de preço");
        return;
      }

      this.showViewItem = true;
      this.itemView = selectedItem;

      //ADICIONA O ITEM NO ARRAY pedvit_update
      (this.pedvit_update = { ...this.$store.getters.getEntities.pedvit }),
        (this.pedvit_update.coditem = selectedItem.coditem);
      this.pedvit_update.descricao = selectedItem.descricao;
      this.pedvit_update.item = [];
      this.pedvit_update.item.push({
        descricao: selectedItem.descricao,
        codigo: selectedItem.codigo
      });
      this.pedvit_update.coditemgrade = selectedItem.coditemgrade;
      this.pedvit_update.uni = selectedItem.uni;
      this.pedvit_update.vlr = selectedItem.vlrtab;
      this.pedvit_update.qtuni = selectedItem.quantidade;
      this.pedvit_update.obs = selectedItem.obs;

      // Adiciona item que acaba de ser incluido na rotina da fila de requisição
      this.filaRequicaoItens.push(this.pedvit_update);

      this.calculaItem(true);

      //DISPARA O TIMER PARA GRAVACAO DO PEDIDO
      let vm = this;
      if (this.apiTimer) {
        clearTimeout(this.apiTimer);
      }

      this.apiTimer = setTimeout(function () { vm.gravaItem(false, false); }, 500);

      this.coditem = null;
      this.qtdItemInformada = 0;
      this.informed_qt = false;

      if (this.vendaManual) {
        this.$nextTick(function () {
          this.itemView = {};
          this.vlrItemInformado = 0;
          this.selectedItem = {};
          this.showViewItem = false;
        });
        this.focusItem()
      }
    },

    selectNewItem(selectedItem) {
      //AO SELECIONAR UM ITEM NA PESQUISA, ADICIONA O ITEM NA VENDA
      if (this.qtdItemInformada) {
        selectedItem.quantidade = this.qtdItemInformada;
      }

      if (selectedItem.vlrtab) {
        this.vlrItemInformado = selectedItem.vlrtab
      }

      this.item_waiting = true;
      this.showViewItem = true;
      this.selectedItem = selectedItem;
      this.itemView = selectedItem;
      this.$nextTick(function () {
        this.$refs.qtdItemInformada.focus();
      });

    },
    handleTypeofSell(selectedItem) {
      if (this.vendaManual) {
        this.selectNewItem(selectedItem);
      } else {
        this.handleNewItem(selectedItem);
      }
    },
    handleQtd(selectedQt) {
      if (selectedQt) {
        this.qtdItemInformada = selectedQt;
        this.informed_qt = true;
      }
    },
    handleModalVendasEspera() {
      if (this.showVendas) {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle')
        })
        this.showVendas = false;
        this.focusItem()
      } else {
        this.showVendas = true;
      }
    },
    async handleResult(params, result) {
      if (result == "OK") {
        if (params) {
          await this.$store.dispatch("loadPedv", { id: params });
          if (this.$store.getters.getPedv) {
            this.pedv = { ...this.$store.getters.getPedv[0] };
            this.pedvit = this.pedv.pedvit;

            if (this.pedv.pedvpar) {
              this.pedvpar = this.pedv.pedvpar;
            }
            this.selectedPart = null;
            this.codpart = this.pedv.codpart;
            this.carregaDadosCliente();
            if (this.pedv.codnf) {
              await this.$store.dispatch("loadNf", { id: this.pedv.codnf });
              if (this.$store.getters.getNf) {
                this.pedv.nf = { ...this.$store.getters.getNf[0] };
              }
            }
          }

          this.showViewItem = false;
          this.$nextTick(function () {
            this.$refs.item.focus();
          });
        }
      }
    },
    handleVmovCaixaForm(valuetpmovcaixa) {
      this.paramsvmovcaixa.tpmovcaixa = valuetpmovcaixa;
      this.paramsvmovcaixa.codvabertura = this.vabertura.codvabertura;
      this.showVmovCaixaForm = true;
    },

    async handleResultadoVmovCaixaForm(paramvmovcaixa, result) {
      this.showVmovCaixaForm = false;

      if (result == "RETORNA") {
        return;
      }

      if (result == "OK") {
        if (paramvmovcaixa) {
          let vmovc = paramvmovcaixa;
          vmovc.codvabertura = this.vabertura.codvabertura;

          this.apiVarejoVMovCaixa(vmovc, false, this.responseVmovcaixa);
        }
      }

      this.$nextTick(() => {
        this.$refs.item.focus();
      });
    },

    responseVmovcaixa(vmovcaixa, errmessages) {
      this.errmessages = errmessages;

      if (this.errmessages == null || this.errmessages.length <= 0) {
        this.vmovcaixa = vmovcaixa
        this.showEmissaoCupomVmov = true
      } else {
        for (var x = 0; x < this.errmessages.errmessages.length; x++) {
          this.$erpToastError(this.errmessages.errmessages[x]);
        }

        this.errmessages = {};
      }

    },

    handleAberturaCaixa() {
      this.showVAbertura = true;
    },

    async handleResultadoVabertura(paramvabertura, result) {
      if (result == "RETORNA") {
        this.$router.push("/varejolist");
        let body = document.querySelector("body");
        body.style.overflow = "auto";
        return;
      }

      let vabertura = null;

      if (result == "TROCARUSUARIO") {
        vabertura = this.vabertura
        vabertura.aberto = "S";
        vabertura.dtfechamento = null;
      }

      if (result == "OK") {
        if (paramvabertura) {
          vabertura = paramvabertura;
          vabertura.aberto = "S";
          vabertura.dtfechamento = null;
          if (vabertura.aberturadecaixa)
            vabertura.codvabertura = null
        }
      }

      if (vabertura) {
        var sendData = { vabertura: vabertura };

        let metodo = "post";
        let endpoint = 'varejo/vabertura/'
        if (vabertura.codvabertura)
          endpoint += vabertura.codvabertura
        else
          endpoint += '0'

        const data = await apiORDSpost(this.$store, endpoint, sendData, metodo).then();
        if (!data.items) {
          this.$router.push('/varejolist')
          return;
        }

        this.vabertura = data.items[0];
        this.showVAbertura = false;
        this.$erpToastSuccess("Abertura do caixa efetuada com sucesso");

        this.$nextTick(function () {
          this.$refs.item.focus();
        });
      }
    },

    PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != "success") {
        this.$erpToastError(response.message);
      }
    },

    handleClickImprimir() {
      if (this.pedv.nf) {
        if (this.pedv.nf.esp == "59") {
          let paramsimp = "&codnf=" + this.pedv.nf.codnf;
          this.$executaExtensaoChromeSAT(
            this.pedv.nf.codnf,
            "imp",
            this.PDFResponseCallbackSAT,
            paramsimp
          );
          return;
        } else {
          apiDownloadPDF(
            this,
            "print/danfe/" + this.pedv.nf.codnf,
            null,
            null,
            true,
            null,
            true
          );
        }
      } else {
        if (!this.pedv.codpedv) {
          this.$erpToastError("Pedido não informado");
          return;
        } else {
          this.showEmissaoCupomVmov = false;
          this.savedOrder = this.pedv.codpedv
          this.showEmissaoCupom = true;
        }
      }
    },

    handleShowDestaques() {
      this.showDestaques = true;
    },

    handleCloseDestaques() {
      this.showDestaques = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },

    async handleClickPagamento() {
      //EXIBE O FORM DE PAGAMENTO DA VENDA
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }

      await this.gravaItem(false, false);
      if (
        !this.errmessages ||
        !this.errmessages.errmessages ||
        this.errmessages.errmessages.length < 0
      ) {
        this.paramsPagamento = {
          totalVenda: this.pedv.totger,
          data: this.pedv.data,
          codpart: this.codpart,
          email: this.pedv.emaildanfe,
          pedv: this.pedv,
          pedvit: this.pedvit,
          paramscaixa: PARAMS_CAIXA
        };
        this.showPagamentoVenda = true;
      }
    },

    async handleResultadoPagamento(listPagamentos, selectedPart, email, result) {
      //TRATA O RESULTADO DO PAGAMENTO DA VENDA
      //COLOCA VENDA EM ESPERA
      //ENCERRA A VENDA COM O PAGAMENTO

      // if (selectedPart) {
      //   if (selectedPart.codpart)
      //     this.codpart = selectedPart.codpart;
      //   else
      //     this.codpart = selectedPart.cnpjcpf;
      //   await this.carregaDadosCliente();
      //   this.pedv.codpart = selectedPart.codpart;
      //   this.pedv.cpfcnpj = selectedPart.cnpjcpf;
      // }

      this.pedv.emaildanfe = email;

      if (result == "RETORNAVENDA") {
        this.showPagamentoVenda = false;
        this.$nextTick(function () {
          this.$refs.item.focus();
        });
        return;
      }

      if (!result)
        return;

      this.finalizaVendaAction = result;
      this.savedOrder = this.pedv.codpedv
      this.pedv.listPagamentos = listPagamentos;
      this.pedv.vendaFinalizada = true;
      this.handleGravaPedido(false);
    },

    executaSAT() {
      this.autorizaNFeSAT(this.pedv.nf, this.NFeResponseCallbackSAT);
    },

    NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT

      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (
          response.response.nf.length > 0 &&
          response.response.nf[0].cstat == "100"
        ) {
          this.handleGravaPedido(false);
          this.$erpToastSuccess("SAT Autorizado");
        } else {
          this.pedv.nf.xmotivo = response.response.xmotivo;
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.index = this.pedv.codpedv;
      this.limparTela();
    },

    NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      let rejeitada = false;
      let msg = []
      this.errmessages = {};

      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          rejeitada = false;
        } else {
          this.pedv.nf.xmotivo = response.response.xmotivo;
          msg.push(response.data.nf[0].xmotivo)
          // this.$erpToastError(response.response.xmotivo);
          rejeitada = true;
        }
      }

      if (rejeitada) {
        this.$refs.modalnfce.rejeitada(msg)
        if (this.params_pdv.ir_para_emissao_nf == "NF") {
          this.index = this.pedv.codpedv;
          this.loadData().then(function () {
            this.$router.push("/nf/" + this.pedv.codnf + "?tipo=view");
            return
          })
        } else {
          this.handleNovaVenda()
        }
      } else {
        this.index = this.pedv.codpedv;
        this.loadData().then(function () {
          //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
          if (this.pedv.nf.stnf == 10) {
            this.handleClickImprimir();
          }
          this.showModalnfce = false
          this.handleNovaVenda();
        })
      }

    },

    async NFeResponseCallbackA1(response) {
      let rejeitada = false;
      let msg = []
      if (response.data) {
        if (response.data.errmessages)
          rejeitada = true;
        if (response.data.nf && response.data.nf.length > 0) {
          this.pedv.nf = response.data.nf[0]
          if (response.data.nf[0].cstat != "100") {
            rejeitada = true
            msg.push(response.data.nf[0].xmotivo)
          }
        }
      }
      if (rejeitada) {
        this.$refs.modalnfce.rejeitada(msg)
        if (this.params_pdv.ir_para_emissao_nf == "NF" && this.pedv.nf) {
          this.$router.push("/nf/" + this.pedv.nf.codnf + "?tipo=view");
          return
        } else {
          this.handleNovaVenda();
        }
      } else {
        //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
        this.showModalnfce = false
        if (this.pedv.nf.cstat == "100") {
          this.handleClickImprimir();
        }
        this.handleNovaVenda();
      }
    },

    async confirmaItemCancel() {
      //remove o item do pedido
      if (this.showModalEditItem) {
        this.showModalEditItem = false;
      }

      this.pedvit[this.pedvit_update].stpedv = "C";
      this.gravaItem(true, false);
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    handleCancelEditItem(index) {
      //CARREGA DADOS DO CAIXA
      this.pedvit[index].qtuni = this.pedvit_beforeUpdate.qtuni;
      this.pedvit[index].vlr = this.pedvit_beforeUpdate.vlr;
      this.pedvit[index].pdesc1 = this.pedvit_beforeUpdate.pdesc1;
      this.pedvit[index].obs = this.pedvit_beforeUpdate.obs;
      this.$set(this.pedvit[index], "editing", false);
      this.pedvit_beforeUpdate = {};

      this.pedvit_index = "";
      this.item_editing = false;
    },
    handleButtonEditItem(index) {
      this.editItemValue = index;
      this.handleEditItem(index);
    },
    handleButtonDeleteItem(index) {
      this.editItemValue = index;
      this.handleShowModalEditItem("delete");
    },
    handleEditItem(index) {
      if (this.editItemValue) {
        index--;
        this.editItemValue = null;
        this.showModalEditItem = false;
        this.item_editing = true;
        this.pedvit_index = index;
      }

      let store = this.pedvit_beforeUpdate;
      store.qtuni = this.pedvit[index].qtuni;
      store.vlr = this.pedvit[index].vlr;
      store.pdesc1 = this.pedvit[index].pdesc1;
      store.obs = this.pedvit[index].obs;

      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") {
        return;
      }

      //CLICK NO ITEM DA VENDA - ABRE PARA EDICAO DA QUANTIDADE, PREÇO, DESCONTO
      if (this.pedvit[index].editing) {
        this.pedvit[index].editing = false;
        this.gravaItem(false, false);
        this.$nextTick(function () {
          this.$refs.item.focus();
        });
        this.item_editing = false;
        this.pedvit_index = "";
      } else {
        this.$set(this.pedvit[index], "editing", true); //PARA ABRIR OS DADOS DO ITEM
        this.pedvit[index].editing = true;

        this.$nextTick(function () {
          this.$refs.quantidade.focus();
        });
      }

      if (this.showModalEditItem) {
        this.closeModalEditItem();
      }
    },

    handleRetorna() {
      this.closeForm();
    },

    handleDescartarVenda() {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.CANCEL_MESSAGE = true;
      }
      this.handleViewItem();
    },
    handleCancelarVenda() {
      this.handleCloseMessage();
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.pedv.stpedv = "C";
        this.handleGravaPedido(true);
        this.limparTela();
        this.novavenda();
        this.$erpToastSuccess("A venda foi descartada");
      }
      if (this.itemView) {
        this.handleViewItem();
      }
    },

    handleVendaEspera() {
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.pedv.espera = "S";
        this.handleGravaPedido(false);
        this.novavenda();
        this.$erpToastSuccess("A venda foi colocada em espera");
      }
      if (this.itemView) {
        this.handleViewItem();
      }
    },

    limparTela() {
      // this.pedv = { ...this.$store.getters.getEntities.pedv };
      // this.codpart = null;
      // this.selectedPart = null;
      // this.carregaDadosCliente();
      this.novavenda()
    },

    handleNovaVenda(showMsg) {
      this.showPagamentoVenda = false;
      if (!this.params_pdv.tipo_controle_cm_ms) {
        this.novavenda()
        if (showMsg)
          this.$erpToastSuccess("Nova Venda Iniciada")
      } else {
        this.handleShowModalMesaComanda();
      }
    },

    novavenda() {
      this.showFullScreenRequest = false;
      this.pedv = { ...this.$store.getters.getEntities.pedv };
      this.pedv.varejo = "S";
      this.pedv.stpedv = "D";
      this.pedv.data = this.$getDate();
      this.pedv.finalidade = "F";
      this.pedv.indpresencial = "0";
      this.pedv.bonif = "N";
      this.pedv.amostra = "N";
      this.pedv.pgantecipado = "N";
      this.pedv.tpfrete = "0";
      this.pedv.tppedv = "P";
      this.pedvit = [];
      this.pedv.pedvit = this.pedvit;
      this.pedv.obspedido = this.params_pdv.observacao;
      this.selectedPart = null;
      this.codpart = this.pedv.codpart;

      this.errmessages = {};

      this.$nextTick(function () {
        this.$refs.item.focus();
      });

      this.itemView = {};
    },

    async handleGravaPedido(cancel) {
      this.pedv.pedvit = this.pedvit;
      this.pedv.codvabertura = this.vabertura.codvabertura;
      this.pedv.codpart = this.selectedPart ? this.selectedPart.codpart : null;
      this.pedv.cpfcnpj = this.selectedPart ? this.selectedPart.cnpjcpf : null;

      this.handleGrade();

      let pedv = this.pedv;

      if (this.pedv.pedvit && this.pedv.pedvit.length > 0) {
        await this.apiVarejoPedido(
          pedv,
          pedv.pedvit,
          null,
          cancel,
          this.responsePedido
        );
      }
    },

    responsePedido(pedv, errmessages) {
      this.pedv = pedv;
      this.pedvit = pedv.pedvit;

      if (errmessages && errmessages.errmessages && errmessages.errmessages.length > 0) {
        for (var x = 0; x <= errmessages.errmessages.length; x++) {
          console.log(errmessages.errmessages[x]);
          this.$erpToastError(errmessages.errmessages[x]);
        }
        return;
      }
      //Existem produtos sem estoque que devem ser removidos do pedido

      this.pedv.atualizado = true;
      if (this.finalizaVendaAction)
        this.emiteDocumento()
      else {
        this.loadMesaComanda();
        this.handleNovaVenda();
      }

    },

    handleGrade() {
      if (this.pedvit && this.pedvit.length) {
        for (var x = 0; x < this.pedvit.length; x++) {
          if (this.pedvit[x].coditemgrade) {
            this.pedvit[x].pedvgrade = [];
            let pedvgrade = {};
            pedvgrade.coditemgrade = this.pedvit[x].coditemgrade;
            pedvgrade.qt = 1;
            this.pedvit[x].pedvgrade.push(pedvgrade);
          }
        }
      }
    },

    handleDescricaoGrade() {
      if (this.pedvit && this.pedvit.length)
        for (var x = 0; x < this.pedvit.length; x++) {
          let item = this.pedvit[x];
          if (item.pedvgrade && item.pedvgrade.length > 0) {
            if (item.pedvgrade[0] && item.pedvgrade[0].descricao_linha)
              this.pedvit[x].item[0].descricao =
                item.item[0].descricao +
                " " +
                item.pedvgrade[0].descricao_linha;
            if (item.pedvgrade[0] && item.pedvgrade[0].descricao_coluna)
              this.pedvit[x].item[0].descricao =
                item.item[0].descricao +
                " " +
                item.pedvgrade[0].descricao_coluna;
          }
        }
    },

    emiteDocumento() {
      if (this.finalizaVendaAction == "NFe") {
        this.showModalnfce = true
        this.finalizaVendaAction = null;
        let self = this;
        this.apiGerarNF('55').then(function () {
          let tipo = self.$certificadoCheck(self.pedv.nf.codfil);
          self.$refs.modalnfce.enviando()
          if (tipo == "A1") {
            self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1)
          } else if (tipo == "A3") {
            self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3)
          }
        });
      }
      if (this.finalizaVendaAction == 'NFCe') {
        this.finalizaVendaAction = null
        this.showModalnfce = true
        let self = this
        this.apiGerarNF('65').then(function () {
          let tipo = self.$certificadoCheck(self.pedv.nf.codfil)
          self.$refs.modalnfce.enviando()
          if (tipo == 'A1') {
            self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1)
          } else if (tipo == "A3") {
            self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3)
          }
        });
      }
      if (this.finalizaVendaAction == "SAT") {
        this.finalizaVendaAction = null;
        let self = this;
        this.apiGerarNF('59').then(function () {
          self.executaSAT();
        });
      }
      if (this.finalizaVendaAction == "PRINT") {
        this.showEmissaoCupomVmov = false;
        this.savedOrder = this.pedv.codpedv
        this.showEmissaoCupom = true;
        this.handleNovaVenda()
      }
      if (this.finalizaVendaAction == "OK") {
        this.handleNovaVenda()
      }

      this.finalizaVendaAction = null;
    },

    async gravaItem(cancelItem, deleteItem) {
      let hasItem = false;

      if (this.runningItemRequest) return;

      this.runningItemRequest = true;

      this.filaRequicaoItens.map(item => {
        if (this.params_pdv.agrupar_itens_pedido) {
          this.pedv.pedvit.forEach((e, i) => {
            if (e.coditem == item.coditem) {
              hasItem = true;
              this.pedv.pedvit[i].qtuni += item.qtuni;
            }
          });
        }

        if (!this.params_pdv.agrupar_itens_pedido || !hasItem) {
          this.pedv.pedvit.push(item);
          this.pedvit = this.pedv.pedvit;
          this.$refs.divitems.scrollTop = this.$refs.divitems.scrollHeight;
        }
      });

      this.filaRequicaoItens = [];

      this.pedv.codpart = this.selectedPart ? this.selectedPart.codpart : null;
      this.pedv.cpfcnpj = this.selectedPart ? this.selectedPart.cnpjcpf : null;
      this.pedv.varejo = "S";
      this.pedv.st = "P";
      this.pedv.codtabpre = this.params_pdv.tabela_preco;

      if (this.hasComandaControl) {
        if (!this.pedv.codpedv) {
          this.$set(this.pedv, "comanda", this.codcomanda);
          this.pedv.comanda = this.codcomanda;
          this.codcomanda = "";
        }
      }
      this.handleGrade();

      if (this.pedvit.length <= 1 && cancelItem) {
        this.handleCancelarVenda();
      }

      this.pedvit.forEach(e => (e.codtabpre = this.params_pdv.tabela_preco));

      this.pedv.pedvit = this.pedvit;

      this.calculaItem();

      this.pedv.codvabertura = this.vabertura.codvabertura;

      let pedv = this.pedv;

      await this.apiVarejoPedido(
        pedv,
        pedv.pedvit,
        null,
        false,
        this.responseVarejoPedido
      );

      await this.loadMesaComanda();
    },

    responseVarejoPedido(pedv, errmessages) {
      this.pedv = pedv;
      this.pedvit = pedv.pedvit;
      this.handleDescricaoGrade();

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();

      if (
        errmessages == null ||
        !errmessages.errmessages ||
        errmessages.errmessages.length <= 0
      ) {
        this.pedv.atualizado = true;
      } else {
        for (var x = 0; x < errmessages.errmessages.length; x++) {
          console.log(errmessages.errmessages[x]);
          this.$erpToastError(errmessages.errmessages[x]);
        }
      }
      this.loadMesaComanda();

      this.runningItemRequest = false;

      if (this.filaRequicaoItens.length > 0) {
        this.gravaItem(false, false);
      }
    },

    handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },

    textOption(value, field) {
      var item = field.options.filter(x => x.id === value);
      if (item.length) {
        return item[0].text;
      }
    },

    validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true;

      if (
        this.pedv.nates &&
        this.pedv.nates.length &&
        this.pedv.nates[0].stnates == "I"
      ) {
        this.$erpToastError("A Natureza de saída informada está inativa");
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stcred != "L") {
        this.$erpToastError("Cliente com crédito bloqueado");
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stpart == "I") {
        this.$erpToastError("Cliente inativo");
        this.isValidCabec = false;
      }
      return this.isValidCabec;
    },

    loadVendaEspera(codpedv) {
      if (!codpedv)
        return

      this.handleModalVendasEspera()

      this.index = codpedv
      this.loadData()
    },

    async loadData() {
      //carrega o pedido para alteracao ou visualizacao
      // if (!this.index)
      //   return

      this.unwatch = true;
      await this.$store.dispatch("loadPedv", { id: this.index });
      if (this.$store.getters.getPedv) {
        this.pedv = { ...this.$store.getters.getPedv[0] }
        if (this.pedv.pedvit)
          this.pedvit = this.pedv.pedvit
        if (this.pedv.pedvpar) {
          this.pedvpar = this.pedv.pedvpar;
        }

        this.handleDescricaoGrade();
        this.selectedPart = null;
        this.codpart = this.pedv.codpart;
        this.carregaDadosCliente();
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
        this.unwatch = false;
      });
    },

    async loadPedvAtualUsuario() {
      //carrega o pedido para alteracao ou visualizacao
      this.unwatch = true;
      await this.$store.dispatch("loadPedvAtualUsuario", {
        id: this.$store.getters.getEnv.uuid
      });
      if (this.$store.getters.getPedv) {
        this.pedv = { ...this.$store.getters.getPedv[0] }
        if (this.pedv.pedvit)
          this.pedvit = this.pedv.pedvit
        if (this.pedv.pedvpar) {
          this.pedvpar = this.pedv.pedvpar;
        }

        this.handleDescricaoGrade();
        this.selectedPart = null;
        if (this.pedvit && this.pedvit.length > 0) {
          this.codpart = this.pedv.codpart;
          this.carregaDadosCliente();
          this.$erpToastSuccess(
            'Pedido não finalizado carregado com sucesso! Para iniciar uma nova venda coloque essa em espera em "mais Ações"'
          );
        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
        this.unwatch = false;
      });
    },

    async carregaDadosCliente() {
      if (this.codpart && this.codpart != "") {
        if (CpfValidate(this.codpart.toString())) {
          let part = { ...this.$store.getters.getEntities.part };
          part.codpart = null;
          part.cnpjcpf = this.codpart;
          part.nome = "CONSUMIDOR FINAL";
          this.selectedPart = part;
          this.pedv.cpfcnpj = part.cnpjcpf;
        } else {
          await this.$store.dispatch("loadPart", { id: this.codpart });
          if (this.$store.getters.getPart) {
            this.selectedPart = { ...this.$store.getters.getPart[0] };
          }

        }
      }
      if (this.showPagamentoVenda)
        this.$refs.pagamentoVenda.loadCreditoLoja(this.selectedPart)
    },

    handleResultadoEmissaoCupom() {
      this.showEmissaoCupom = false;
      this.showEmissaoCupomVmov = false;
    },

    hasBgconfig(onlyBgOption) {
      if (this.params_pdv) {
        if (onlyBgOption) {
          return `background-color: ${isValidHashColor(this.params_pdv.colors.bg_top_bottom)
            ? this.params_pdv.colors.bg_top_bottom
            : "#174b79"
            }; color:${isValidHashColor(this.params_pdv.colors.fc_top_bottom)
              ? this.params_pdv.colors.fc_top_bottom
              : "white;"
            }!important;`;
        } else {
          return `background-color: ${isValidHashColor(this.params_pdv.colors.bg_top_bottom)
            ? this.params_pdv.colors.bg_top_bottom
            : "#174b79"
            }; color:${isValidHashColor(this.params_pdv.colors.fc_top_bottom)
              ? this.params_pdv.colors.fc_top_bottom
              : "white;"
            }!important; border-bottom: 1px solid #e9e5e5; height: 30px;`;
        }
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgButtomconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return `background-color: ${isValidHashColor(this.params_pdv.colors.bg_buttom)
          ? this.params_pdv.colors.bg_buttom
          : "#174b79"
          }; color:${isValidHashColor(this.params_pdv.colors.fc_buttom)
            ? this.params_pdv.colors.fc_buttom
            : "white;"
          }!important;`;
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgConfirmconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return `background-color: ${this.params_pdv.colors.bg_buttom
          ? this.params_pdv.colors.bg_buttom
          : "#37648b"
          }; color:${this.params_pdv.colors.fc_buttom
            ? this.params_pdv.colors.fc_buttom
            : "white;"
          }!important;`;
      } else {
        return "background-color: #b5e792; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    handlePushState(event) {
      history.pushState(null, null, document.URL);
    },

    isModalActive() {
      if (this.showModalAcrescimo || this.showModalDesconto || this.showModalEditItem ||
        this.showModalCliente || this.showModalMesa || this.showModalComanda || this.showModalMaisAcoes || this.showModalPendcli)
        return true
      else
        return false
    },

    isVendaAberta() {
      if (this.pedvit && this.pedvit.length > 0)
        return true
      else
        return false
    },

    handleKeyPress(event) {
      let self = this;

      // desabilita tecla F3, F5, F6 do navegador
      if (event.keyCode === 116 || event.keyCode === 114 || event.keyCode === 117)
        event.preventDefault()

      // console.log(event.keyCode)

      if (!this.isModalActive()) {
        // F2
        if (event.keyCode === 113 && !self.showPagamentoVenda) {
          self.handleNovaVenda(true);
          return;
        }

        // F4
        if (event.keyCode === 115 && self.isVendaAberta()) {
          self.handleModalCliente();
          return;
        }

        // F3
        if (event.keyCode === 114 && self.showPagamentoVenda) {
          if (this.params_pdv.permite_desconto || this.params_pdv.permite_acrescimo) {
            self.handleInformarDesconto()
          }
          return;
        }

        // F3
        if (event.keyCode === 114 && !self.showPagamentoVenda) {
          self.handleModalVendasEspera()
          return
        }

        // F5
        if (event.keyCode === 116) {
          if (!self.showPagamentoVenda)
            self.handleDescartarVenda()
          return
        }

        // F6
        if (event.keyCode === 117 && !self.showPagamentoVenda) {
          self.handleClickPagamento()
          return;
        }

        // F9
        if (event.keyCode === 120 && !self.showPagamentoVenda) {
          self.focusItem()
          return
        }
      }

      // ESC
      if (event.keyCode === 27) {
        if (self.showModalEditItem) {
          self.closeModalEditItem();
          return;
        } else
          if (this.showVendas) {
            this.handleModalVendasEspera()
            return;
          } else
            if (self.showModalDesconto || self.showModalAcrescimo) {
              self.closeModalDescontoAcrescimo()
              return;
            } else
              if (self.showModalEditItem) {
                self.closeModalEditItem();
                return;
              } else
                if (self.showModalCliente) {
                  self.closeModalCliente();
                  return;
                } else
                  if (self.showModalMesa) {
                    self.handleCloseModalMesa();
                    return;
                  } else
                    if (self.showModalComanda) {
                      self.handleCloseModalComanda();
                      return;
                    } else
                      if (self.showModalPendcli) {
                        self.closeModalPendcli();
                        return;
                      } else
                        if (self.showPagamentoVenda) {
                          if (self.$refs.pagamentoVenda.$refs.paymentType.focused) {
                            self.showPagamentoVenda = false;
                            self.focusItem();
                          } else {
                            self.$refs.pagamentoVenda.$refs.paymentType.focus()
                          }
                          return;
                        } else
                          if (self.inFocus) {
                            //Voltar ao campo do item
                            this.focusItem()
                          }
        if (self.modoView) {
          this.focusItem
          self.modoView = false;
          self.$refs.item.handleisView(self.modoView);
        }
        if (this.$refs.qtdItemInformada && this.$refs.qtdItemInformada.focused) {
          this.focusItem()
          return;
        }
        if (this.$refs.vlrItemInformado && this.$refs.vlrItemInformado.focused) {
          this.$refs.qtdItemInformada.focus()
          return;
        }
      }

      // ALT EVENT
      if (event.altKey) {
        switch (event.keyCode) {
          case 80: // Pagamento (Alt + P)
            self.handleClickPagamento();
            break;
          case 79: // Manda Foco para Seleção de Atalho (Alt + O)
            event.preventDefault()
            self.showModalMaisAcoes = true;
            break;
          case 68: // alt + D
            event.preventDefault()
            self.handleSelectedOption('excluir');
            // self.handleShowModalEditItem('delete');
            break;
          case 70: // alt + F
            event.preventDefault()
            self.handleSelectedOption('fecharcaixa'); //handleFecharCaixa();
            break;
          case 83: // alt + S
            event.preventDefault()
            self.handleSelectedOption('sangrar');
            // self.showConfirmAdminPass(self.handlerSangrar);
            break;
          case 82: // alt + R
            event.preventDefault()
            self.handleSelectedOption('reforcar');
            // self.showConfirmAdminPass(self.handlerReforcar);
            break;
        }
      }

    }
  },

  watch: {
    editItemValue(n) {
      if (n == null || n == "") {
        this.errMessageModalEditItem = "";
      }
    },

    codpart: function () {
    },

    vabertura: {
      handler: function (newValue) {
        if (newValue)
          this.caixa = newValue.caixa  //descricao do caixa no topo da tela
        else
          this.caixa = null
      },
      immediate: true,
      deep: true
    },
  },

  created() {
    //this.$store.dispatch('clearItemSales')
    this.filial = null;
    this.handleParamPDV();

    let index = null;

    setTimeout(function () {
      Tawk_API.hideWidget();
    }, 1000);

    this.metadata.pedv.parcelas.options.sort(function (a, b) {
      return Number(a.id) > Number(b.id)
        ? 1
        : Number(b.id) > Number(a.id)
          ? -1
          : 0;
    });

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crud = SysVars.crudI;
    this.crudText = this.$crudText(this.crud);

    this.$scrollTo(0);

    // this.$store.dispatch("loadItemSales", {
    //   codtabpre: this.params_pdv.tabela_preco
    // });
  },

  beforeDestroy() {
    let body = document.querySelector("body");
    body.style.overflow = "auto";
    window.removeEventListener("popstate", this.handlePushState);
    window.removeEventListener("keydown", this.bound_handleKeyPress);
  },

  async mounted() {
    this.handlePushState
    window.addEventListener("popstate", this.handlePushState);

    let index = null;
    var self = this;


    await this.loadFilial();
    await this.loadAbertura();
    // this.hasBgconfig();

    if (this.$route.params) {
      if (this.$route.params.novo == "novo") incluir = true;
      else if (this.$route.params.novo) index = this.$route.params.novo;
    }

    if (this.vabertura) {
      if (
        !index &&
        this.$store.getters.getEnv.uuid &&
        !this.hasMesaControl &&
        !this.hasComandaControl &&
        !this.hasMesaComandaControl
      ) {
        //this.loadPedvAtualUsuario();
      } else {
        this.handleResult(index, "OK");
        if (this.hasMesaControl || self.hasMesaComandaControl) {
          this.handleShowModalMesaComanda();
        } else if (self.hasComandaControl) {
          this.handleShowModalMesaComanda();
        }
      }
    }

    var self = this;
    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();

      if (
        !self.hasMesaControl &&
        !self.hasComandaControl &&
        !self.hasMesaComandaControl
      ) {
        if (self.$refs.item) self.$refs.item.focus();
      }
    });


    this.bound_handleKeyPress = this.handleKeyPress.bind(this)
    window.removeEventListener("keydown", this.bound_handleKeyPress)
    this.windowListener = window.addEventListener("keydown", this.bound_handleKeyPress)


    //Retira barra de rolagem da tela
    document.querySelector("body").style.overflow = "hidden";

    this.windowHeight = window.innerHeight;

    if (this.windowHeight > 663) {
      this.showFullScreenRequest = false;
    }

    //Verifica tamanho da tela para renderizar alert ao usuário
    window.addEventListener("resize", async () => {
      this.windowHeight = window.innerHeight;
      if (this.windowHeight > 663) {
        this.showFullScreenRequest = false;
      } else {
        this.showFullScreenRequest = true;
      }
    });
  }
};
</script>

<template>
  <div ref="varejoform">
    <div class="nb-modal-varejo ">
      <div class="header">
        <varejo-bar-top :pedv="pedv" :params_msg="params_pdv.default_header_title" :params_colors="params_pdv.colors"
          :showBtnConfig="!showPagamentoVenda" :config="showModalMaisAcoes" :caixa="caixa" @action="getAction"
          @logout="handleClosePDV" @config="handleConfig"></varejo-bar-top>
      </div>
      <div class="ml-md-auto mt-2"></div>
      <!-- FORMULARIO PRINCIPAL DA VENDA -->
      <div class="mx-2">
        <div v-if="pedv && pedv.nf && pedv.nf.xmotivo && pedv.nf.stnf != '10'" class="col-6 error">
          {{ pedv.nf.xmotivo }}
        </div>
        <div class="d-flex justify-content-center" style="gap: 20px;">
          <!-- LADO ESQUERDO PESQUISA DE ITENS E LISTA DE ITENS PREFERENCIAIS -->
          <div class=" d-flex flex-row col-md-6 col-12 pr-0 "
            style="height: 83vh; max-height: 100%; overflow-y: hidden; overflow-x: hidden; " v-if="!showPagamentoVenda">

            <!-- PESQUISA DE ITENS -->
            <div class="d-flex flex-column align-items-center justify-content-start mt-0 p-0 px-3">
              <div class="mt-0 align-self-center mb-2">
                <varejo-add-item ref="item" v-model="coditem" :add-button="true"
                  :tabela-preco="this.params_pdv.tabela_preco" :balanca="params_pdv.balanca" :showQt="informed_qt"
                  :newQt="qtdItemInformada" @defineQt="handleQtd" @onselect="handleTypeofSell"
                  @setView="showModalViewItem($event)"></varejo-add-item>
              </div>

              <!--QTD E VALOR-->
              <div v-if="this.vendaManual" class="d-flex w-100 mb-3" style="gap:20px; margin-top: -15px;">
                <div class="input-group d-flex flex-column align-items-start" style="width: 40%">
                  <small>Quantidade</small>
                  <input-value ref="qtdItemInformada" class="vd-input px-3 py-2 vend-inputs"
                    style="width: 100%; font-size: 17px!important; padding: 11px;border-radius:5px; border: 1px solid #C9D3DD;"
                    :precision="3" v-model="qtdItemInformada" />
                </div>
                <div class="input-group d-flex flex-column align-items-start" style="width: 60%">
                  <small class="">Valor Unitário (R$)</small>
                  <input-value ref="vlrItemInformado" class="vd-input px-3 py-2 vend-inputs"
                    style="width: 100%; font-size: 17px!important; padding: 11px;border-radius:5px; border: 1px solid #C9D3DD;"
                    :precision="2" v-model="vlrItemInformado" />
                </div>
              </div>
              <button v-if="this.item_waiting" :style="`${hasBgConfirmconfig()}; font-size: 15px`"
                class="mb-2 btn btn-block font-weight-bold" @click="handleNewItem(selectedItem)"
                @keyup.enter="handleNewItem(selectedItem)">
                <span>INCLUIR (ENTER)</span>
              </button>

              <!--VISUALIZAÇÃO DOS ITENS INSERIDOS-->
              <!-- <div class="d-flex flex-column align-items-start nb-margin-bottom" style="z-index:-1"> -->
              <div v-if="showViewItem" class="w-100 mb-2" style="z-index:-1">
                <div class="shadow w-100 img-size img-size-big">
                  <div class="row p-2 mt-2 mb-3">
                    <div class="col-md-10">
                      <span> <strong>{{ itemView.descricao }}</strong> Código {{ itemView.coditem }}</span>
                    </div>
                    <div class="col-md-auto ml-auto">
                      <span> <strong>R$ {{ (itemView.vlrtab * itemView.quantidade) | formatValue(2) }}</strong> </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 text-center align-self-center mt-auto" style="overflow: hidden;">
                      <i class="fa fa-camera py-auto" style="font-size:150px; opacity: 30%;"
                        v-if="!this.itemView.url"></i>
                      <img :src="itemView.url" alt="" class="item-img" style="min-height:200px; max-height: 300px;"
                        v-else />
                      <!-- <div class="mt-1">
                        <span class="lbl" style="font-size:20px">{{ itemView.quantidade | formatValue(2) }}
                          {{ itemView.uni }} X R${{
                            itemView.vlrtab | formatValue(2)
                          }}</span>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- MODALS -->

            <!--Side Comadas e mesas -->
            <sidebar-comandas @newSale="handleShowMesaComanda($event), (codmesa = $event)" @close="handleCloseComandas"
              @chosePedidoMesa="
  handleCloseComandas();
handleResult($event, 'OK');
              " @selectedmesa="handleShowModalMesa($event)" :params_pdv="params_pdv" :listComandas="listaComandas"
              :listMesas="listMesas" v-if="showSidebar"></sidebar-comandas>

            <!--Modal Informar Comanda-->
            <div class="to-front modal nb-modal-mask" style="display:block" v-if="showModalComanda">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
                style="overflow-y: initial !important">
                <div class="modal-content">
                  <div class="modal-header" :style="`${hasBgconfig(true)}`">
                    <span class="text-light mr-2" style="font-size:15px">
                      <h4 class="def-title" :style="`color:${params_pdv.colors.fc_top_bottom} !important`
                      ">
                        Informe a Comanda
                      </h4>
                    </span>
                    <button type="button" ref="mesaclose" :style="`color:${params_pdv.colors.fc_top_bottom} !important`
                    " class="close" data-dimiss="modal" aria-label="Close" @click="handleCloseModalComanda()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body d-flex justify-content-center">
                    <div class="my-2">
                      <div style="border: 3px solid black;">
                        <div class="px-3 py-4 text-center" style="border-bottom: 2px solid black">
                          <span class="def-title  text-danger">Número da Comanda</span>
                        </div>
                        <div class="border" style="min-height:70px; max-width:240px">
                          <input type="number" :required="true" ref="comandaid" v-model="codcomanda"
                            class="form-control border-0" style="min-height:68px; font-size:35px"
                            @keydown.enter.stop="handleInformaComanda()" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <v-button danger label="Cancelar" @click.prevent="handleCloseModalComanda()" />
                    <v-button nbBtdef label="Confirmar" @click="handleInformaComanda()" />
                  </div>
                </div>
              </div>
            </div>

            <!--Modal Informar Mesa-->
            <div class="modal nb-modal-mask" style="display:block" v-if="showModalMesa">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
                style="overflow-y: initial !important">
                <div class="modal-content">
                  <div class="modal-header" :style="`${hasBgconfig(true)}`">
                    <span class="text-light mr-2" style="font-size:15px">
                      <h4 class="def-title" :style="`color:${params_pdv.colors.fc_top_bottom} !important`
                      ">
                        Informe a Mesa
                      </h4>
                    </span>
                    <button type="button" ref="mesaclose" :style="`color:${params_pdv.colors.fc_top_bottom} !important`
                    " class="close" data-dimiss="modal" aria-label="Close" @click="handleCloseModalMesa()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="col-12 row mb-2  ">
                      <div class="col-12 mr-5" style="">
                        <span class="lbl-edit">Código da Mesa</span>
                        <input ref="inputmesa" v-model="codmesa" style="font-size:15px;"
                          class=" col-md-4 col-12 form-control " id="search" type="text" autocomplete="off"
                          placeholder="Digite a mesa" @keyup.enter="handleChangeMesa()" />
                      </div>
                    </div>
                    <div class="row col-12 ">
                      <div class="col-md-4 col-5 text-left my-1" v-for="(mesa, index) in listMesas" :key="index"
                        style="padding: 0 15px !important">
                        <button class="d-flex flex-column text-left lista__mesas border border-secondary p-3 col-12"
                          @click="handleChangeMesa(index)" :class="mesa.id == codmesa ? 'border-danger' : ''"
                          style="border-radius: 3px!important; min-height:110px" :style="mesa.pedidos.length > 0
                            ? 'background: #ededed !important'
                            : ''
                          " id="mesa">
                          <strong>{{ mesa.id }} | {{ mesa.descricao }}</strong>
                          <div class="d-flex align-items-center ">
                            <span :class="mesa.pedidos.length > 0 ? 'bg-danger' : ''
                            " class=" translate-middle d-flex justify-content-center  bg-success border  rounded-circle badge-mesa-st"
                              style="top:-10px; z-index:9999; right:5px;">
                            </span>
                            <span :class="mesa.pedidos.length > 0
                              ? 'text-danger ml-2'
                              : 'text-success ml-2'
                            ">{{
    mesa.pedidos.length > 0 ? "Ocupada" : "Vaga"
}}</span>
                          </div>
                          <small>Obs: {{ mesa.obs }}</small>
                          <small v-if="mesa.pedidos.length > 0"><strong>Pedidos</strong>
                            {{ mesa.pedidos.length }}</small>
                          <div v-if="mesa.showObs">
                            <div v-if="hasMesaControl">
                              <span class="lbl-edit mt-2 p-0">Observação</span>
                              <input type="text" v-model="mesaobs" ref="mesaobs" :id="`mesaobs${mesa.id}`"
                                style="font-size:12px" class="form-control" @keyup.enter="$refs.confirmMesaBtn.focus()"
                                @keyup.esc.stop="handleCancelInput(index)" />
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <v-button danger label="Cancelar" @click="handleCloseModalMesa()" />
                    <v-button ref="confirmMesaBtn" nbBtdef label="Confirmar" @click="handleInformaMesa()" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Editar Item -->
            <div class="modal nb-modal-mask" style="display:block" v-if="item_editing"
              @keyup.esc="handleCancelEditItem(pedvit_index)">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
                style="overflow-y: initial !important">
                <div class="modal-content">
                  <div class="modal-body" style="max-height: 100%; overflow-y: auto">
                    <div class="row">
                      <div class="col-md-12 col-12">
                        <span class="lbl mb-4" style="font-size: 20px"><strong>Editar Produto</strong></span>
                        <button type="button" ref="ediitemclose" class="close"
                          @click="handleCancelEditItem(pedvit_index)" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <span class="lbl-deal mb-3"><span class="ml-3 mr-1">{{
                          pedvit[pedvit_index].item[0].codigo
                      }}</span>{{ pedvit[pedvit_index].item[0].descricao }}</span>
                      <div class="d-flex flex-wrap">
                        <form-field ref="quantidade" v-model="pedvit[pedvit_index].qtuni" type="value" col="4"
                          :metadata="metadata.pedvit.qtuni" @change="handleItem"></form-field>
                        <div class="w-100"></div>
                        <form-field v-if="alterapreco != 'N'" v-model="pedvit[pedvit_index].vlr" type="value" col="4"
                          :metadata="metadata.pedvit.vlr"></form-field>
                        <div class="w-100"></div>
                        <form-field v-if="params_pdv.permite_desconto == 'S'" label="% Desconto"
                          v-model="pedvit[pedvit_index].pdesc1" type="value" col="4" :metadata="metadata.pedvit.pdesc1">
                        </form-field>
                        <div class="w-100"></div>
                        <form-field v-model="pedvit[pedvit_index].obs" type="text" class="mr-1" col="6"
                          :metadata="metadata.pedvit.obs"></form-field>
                        <!-- <div class="row" col="1">
                        <v-button class="ml-2" icon="fa-check" @click="handleEditItem(pedvit_index)"></v-button>
                        <v-button class="ml-2" icon="fa-times" @click="handleCancelEditItem(pedvit_index)"></v-button>
                      </div> -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-12 mt-4">
                        <button class="btn btn-success " title="Confirmar" @click="handleEditItem(pedvit_index)">
                          <span>Confirmar</span>
                        </button>
                        <button class="btn btn-outline-secondary ml-2 " title="Cancelar"
                          @click="handleCancelEditItem(pedvit_index)()">
                          <span>Cancelar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <VarejoModalVendas v-if="showVendas" @close="handleModalVendasEspera" @selectedItem="loadVendaEspera" />

            <VarejoModalCaixa v-if="showCaixa" @close="handleFecharCaixa" :caixa="vabertura.codvabertura"
              :params_pdv="params_pdv" />


            <VarejoModalPendcli v-if="showModalPendcli" @close="closeModalPendcli"
              :codvabertura="vabertura.codvabertura" />

          </div>

          <!-- Início Section Destaques -->
          <produtos-destaques :tabela-preco="this.params_pdv.tabela_preco" :itemsList="pedvit" @newItem="handleNewItem"
            @closeDestaques="handleCloseDestaques" v-if="showDestaques"></produtos-destaques>
          <!-- Fim Section Destaques -->

          <!--MODALS-->

          <!--Modal Senha de Confirmarção-->
          <confirm-adminpass v-if="SHOW_CONFIRMADMINPASS" @close="hideConfirmAdminPass()"
            @confirm="confirmAdminPass()" />

          <!--Edição de cliente-->
          <varejo-modal-cliente v-if="showModalCliente" @close="closeModalCliente()"
            @changeCodpart="handleChangeCodPart($event)" :deletar="deletarCliente" :selectedPart="selectedPart"
            :codpartVarejo="codpart" :params_pdv="params_pdv" />

          <varejo-quantidade-item v-if="showModalQtd" @close="closeModalQtd()"
            @getQtdInformada="qtdItemInformada = $event" :params_pdv="params_pdv" />

          <varejo-modal-obs v-if="showModalObs" class="to-front" @close="closeModalObs()"
            @getObs="handleInformaMesa($event)" :pedv="pedv" :params_pdv="params_pdv" />

          <!-- MODAL ACRESCIMO E DESCONTO -->
          <div class="modal nb-modal-mask" style="display:block" v-if="showModalAcrescimo || showModalDesconto">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
              style="overflow-y: initial !important">
              <div class="modal-content">
                <div class="modal-body" style="overflow-y: auto">
                  <div>
                    <div class="row">
                      <div class="col-md-12 col-12">
                        <span class="lbl mb-4" style="font-size: 20px"><strong>Aplicar desconto ou acréscimo na
                            venda</strong></span>
                      </div>
                    </div>
                    <div v-if="this.params_pdv.permite_desconto == 'S'" class="row">
                      <form-field ref="desconto" @input="handlePdesc(pdesc)" v-model="pdesc" label="% Desconto"
                        type="value" :precision="2" col="3" addon="%"></form-field>
                      <form-field :enabled="false" @input="handleVlrDesc(vlrdesc)" v-model="vlrdesc"
                        label="Valor de Desconto" type="value" :precision="2" col="3" preaddon="R$"></form-field>
                    </div>
                    <div v-if="this.params_pdv.permite_acrescimo == 'S'" class="row">
                      <form-field ref="acrescimo" @input="handlePdesp(pdesp)" v-model="pdesp" label="% Acréscimo"
                        type="value" :precision="2" col="3" addon="%"></form-field>
                      <form-field :enabled="false" @input="handleVlrdesp(vlrdesp)" v-model="vlrdesp"
                        label="Valor do Acréscimo" type="value" :precision="2" col="3" preaddon="R$"></form-field>
                    </div>
                    <!-- <div v-if="this.params_pdv.permite_desconto == 'true' ||
                      this.params_pdv.tipo_desconto == 'A' ||
                      this.params_pdv.tipo_desconto == null
                      " class="row">
                      <form-field ref="desconto" @input="handlePdesc(pdesc)" v-model="pdesc" label="Por %" type="value"
                        col="6"></form-field>
                    </div>
                    <div v-if="this.params_pdv.tipo_desconto == 'V' ||
                      this.params_pdv.tipo_desconto == 'A' ||
                      this.params_pdv.tipo_desconto == null
                      " class="row">
                      <form-field ref="" @input="handleVlrDesc(vlrdesc)" v-model="vlrdesc" label="Por Valor"
                        type="value" col="6"></form-field>
                    </div> -->
                    <div class="row">
                      <div class="col-md-12 col-12 mt-4">
                        <button class="btn btn-sm btn-outline-secondary " @click="handleDesconto">
                          <span>Confirmar</span>
                        </button>
                        <button class="btn btn-sm btn-outline-secondary ml-2 " @click="closeModalDescontoAcrescimo()">
                          <span>Cancelar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM MODAL ACRESCIMO E DESCONTO -->

          <transition name="fade" appear>
            <div style="width: 50%">
              <varejo-pag-form v-if="showPagamentoVenda" ref="pagamentoVenda" :showModalCliente="showModalCliente"
                :selectedPart="selectedPart" :params="paramsPagamento" :params_pdv="this.params_pdv"
                @handleModalClientee="handleModalCliente($event)" @showModalDesconto="handleInformarDesconto($event)"
                @resultadopagamento="handleResultadoPagamento"></varejo-pag-form>
            </div>
          </transition>

          <!-- LISTA DE ITENS ADICIONADOS AO PEDIDO -->

          <div class="col-md-6 col-12 p-0 pr-3">
            <div class="nb-margin-bottom d-flex flex-column"
              style="background-color: transparent !important; z-index: -10; width: 100%">
              <div class="">
                <div class="float-left" style="padding-bottom: 4px">
                  <strong style="font-size:12px">Lista de Produtos</strong>
                </div>
              </div>
              <div style="position: relative;min-width: 30vw; width: 100%; z-index: -1; background-color: white;">
                <div class="">
                  <div class="shadow d-flex justify-content-start"
                    style="padding: 11px;border-radius:5px; border: 1px solid #C9D3DD;">
                    <span v-if="!pedv || !pedvit || pedvit.length == 0">Aguardando abertura de pedido. Selecione um
                      produto ou um
                      pedido em aberto.</span>
                    <div class="d-flex justify-content-between" style="width: 100%" v-else>
                      <div class="d-flex" style="gap: 20px">
                        <span style="">Pedido Nº <span>{{ pedv.npedido }} </span></span>
                        <current-date-hour />
                      </div>
                      <span v-if="selectedPart" class="">CNPJCPF:<strong class="ml-2">{{
                          selectedPart.cnpjcpf | formatCNPJCPF
                      }}</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mr-0 ml-0 p-0 shadow nb-margin-bottom navbar-collapse"
              style="height: 58vh; border-radius:5px; border: 1px solid #C9D3DD; overflow-y: scroll">
              <div ref="divitems" class=""
                style="height: 100%; border-radius:10px 10px 0 0; border: none!important; box-shadow: none; padding-inline: 15px; padding: 10px">
                <div v-if="!pedv || !pedvit || pedvit.length == 0"
                  class="d-flex justify-content-center align-items-center"
                  style="margin-bottom: 100px; margin-top: 100px;">
                  <div class="vd-text-grand w-100 text-center">
                    <span style="font-weight:600; margin-left: 30px">
                      Seu caixa está
                      <span style="color: #005ea7">livre</span> no momento!
                    </span>
                    <div class="d-flex justify-content-center w-100 logo-image" :style="`${logoStyle};`"
                      v-if="filial.urlimage">
                      <img :src="filial.urlimage" alt="Logo Filial" style="max-width:80%;" />
                    </div>
                  </div>
                </div>

                <div class="mainbox m-0 overflow-y py-1" v-for="(it, index) in pedvit" :key="index"
                  v-show="it.stpedv != 'C'">
                  <div class="mark-gray p-0 m-0" style="background-color:#005ea7;" v-if="it.editing === true"></div>
                  <div class="d-flex w-100 p-0 m-0 align-items-center">
                    <div class="p-1 m-0 ml-2 justify-content-center">
                      <span class="lbl-title-produto  decrase-lbl-title p-0 text-center">{{ listSequence + index + 1
                      }}</span>
                    </div>
                    <div class="w-100 m-0 p-0">
                      <div class="item-group row m-0 align-items-center">
                        <div class="col-md-12 p-0 m-0 d-flex flex-column">
                          <span class="lbl-title-produto text-dark decrase-lbl-title"
                            style="font-weight:500; word-break: break-all;">{{ it.item[0].descricao }}
                          </span>
                        </div>
                        <div class="col-md-4 p-0 m-0">
                          <span class="lbl decrase-lbl">Cód: {{ it.item[0].codigo }}</span>
                          <span class="lbl decrase-lbl mt-n2" v-if="it.obs">Obs: {{ it.obs }}</span>
                        </div>
                        <div class="col-md-4 p-0 m-0">
                          <div class="float-right">
                            <span class="lbl-title-produto text-dark text-center text-secondary"
                              style="font-weight:400; font-size:14px"><span>{{ it.qtuni }}</span><span class="ml-1">{{
                                  it.uni
                              }}</span></span>
                            <span class="mx-2">X</span>
                            <span class="lbl-title-produto text-dark" style="font-weight:500; font-size:14px">R${{
                                it.vlr | format(2)
                            }}</span>
                          </div>
                        </div>
                        <div class="col-md-4 p-0 m-0">
                          <div class="float-right">
                            <span class="lbl-title-produto text-dark"
                              style="font-size:14px; font-weight:500; word-break: break-all;">
                              Total R$
                            </span>
                            <span class="lbl-title-produto text-dark"
                              style="font-size:14px; font-weight:500; word-break: break-all;">{{ it.totliq | format(2)
                              }}</span>
                          </div>
                          <span class="lbl decrase-lbl float-right" v-if="it.totdes">Desconto ({{ it.totdes | format(2)
                          }})</span>
                        </div>
                      </div>
                    </div>
                    <div class="justify-content-center p-0 m-0">
                      <div class="d-flex float-right" v-if="!showPagamentoVenda">
                        <a class="text-secondary cursor-pointer text-center text-secondary p-0 m-0 "
                          @click="handleButtonEditItem(index + 1)">
                          <i class="fa fa-pencil fa-fw"></i>
                        </a>
                        <a class="text-secondary ml-2 cursor-pointer text-center text-secondary p-0 m-0 "
                          @click="handleButtonDeleteItem(index + 1)">
                          <i class="fa fa-trash fa-fw"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-5"></div>
              </div>
              <div class="d-flex justify-content-center w-100" :style="logoStyle"
                v-if="pedvit && pedvit.length > 0 && filial.urlimage">
                <img :src="filial.urlimage" alt="Logo Filial" style="max-width:50%" />
              </div>

              <!-- <div style="padding: 5px 5px;">
                                    <div class="col text-right">
                                        <v-button label="Informar Desconto (F?)" :nb-btdef="true" title="" :disabled="pedvit.length == 0"></v-button>
                                    </div>
                                </div> -->
            </div>

            <!-- <div class="d-flex row " v-if="!showPagamentoVenda"> -->
            <div class="d-flex row">
              <div class="col-md-12 col-12">
                <div v-if="!showModalAcrescimo && pedv && pedv.vlrdesp > 0"
                  class="d-flex justify-content-between col-12 mb-1">
                  <span class="text-success" style="font-size: 18px"><strong>Acrescimos</strong></span>
                  <span v-if="pedv" class="lbl-title-produto text-success mt-0 pt-0" style="font-size:18px">R$ {{
                      pedv.vlrdesp | format(2)
                  }}</span>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div v-if="!showModalDesconto && pedv && pedv.totdes + pedv.vlrdesc > 0
                " class="d-flex justify-content-between col-12 mb-1">
                  <span class="text-wine-color" style="font-size: 18px"><strong>Descontos</strong></span>
                  <strong v-if="pedv" class="text-wine-color mt-0 pt-0" style="font-size:18px">R$ {{ (pedv.totdes +
                      pedv.vlrdesc) | format(2)
                  }}</strong>
                </div>
                <div class="shadow d-flex justify-content-between"
                  :style="`${hasBgconfig(true)}; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem`">
                  <span v-if="!showPagamentoVenda">Subtotal</span>
                  <span v-if="showPagamentoVenda">Total da Venda</span>
                  <span v-if="pedv">R$ {{ pedv.totger | format(2, true) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER PDV-->
      <div class="footer-varejo d-flex col-12 justify-content-between" style="background-color: white;">
        <div class="d-flex align-items-center justify-content-between px-3 shadow"
          :style="`${hasBgconfig(true)}; border-top-right-radius: 5px; text-align: center; gap: 30px`">
          <div class="d-flex flex-column">
            <span class="font-weight-bold" style="font-size: 14px;">OPERADOR:</span>
            <span v-if="usuarionome" style="text-align: start !important; font-size: 12px;">
              {{ usuarionome }}
            </span>
          </div>
          <div style="text-align: end !important;" class="d-flex flex-column clock pt-1">
            <current-date-hour />
          </div>
        </div>
        <div class="row">
          <div class="mt-1">
            <div class="d-flex justify-content-end">
              <div v-if="!showPagamentoVenda" class="d-flex">
                <button class="blank-button text-button" @click="showModalMaisAcoes = true" :disabled="closeCaixa">
                  <span>(Alt + O) Opções</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleNovaVenda(true)" :disabled="closeCaixa">
                  <span>(F2) Nova Venda</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleModalVendasEspera()" :disabled="closeCaixa">
                  <span>(F3) Vendas Abertas</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleModalCliente()">
                  <span>(F4) Informar CPF</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleDescartarVenda()">
                  <span>(F5) Descartar</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
              </div>
              <div v-if="showPagamentoVenda" class="d-flex">
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleInformarDesconto()" :disabled="!pedv">
                  <span>(F3) Desconto Total</span>
                </button>
                <div style="height: full; padding: 1px; background-color: #eeeeee" />
                <button class="blank-button text-button" @click="handleModalCliente()" :disabled="!pedv">
                  <span>(F4) Informar CPF</span>
                </button>
              </div>
              <button class="blank-button rounded font-weight-bold" v-if="!showPagamentoVenda" :style="!pedv
              ? 'background-color: #797979; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;'
              : hasBgButtomconfig()"
                :disabled="!pedv || !pedvit || pedvit.length == 0 || pedv.stpedv != 'D' || closeCaixa"
                @click="handleClickPagamento">
                <span style="font-size:15px; text-transform: uppercase;">(F6) Pagamento</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <transition name="fade">
        <varejo-vabertura-form v-if="showVAbertura" @resultadovabertura="handleResultadoVabertura">
        </varejo-vabertura-form>
      </transition>

      <transition name="fade">
        <VarejoVmCaixaForm v-if="showVmovCaixaForm" :params="paramsvmovcaixa"
          @resultadovmovcaixa="handleResultadoVmovCaixaForm"></VarejoVmCaixaForm>
      </transition>

      <transition name="fade">
        <VarejoEmissaoCupom v-if="showEmissaoCupom && savedOrder" :index="savedOrder" tipo="cupomnaofiscal"
          @resultadoemissaocupom="handleResultadoEmissaoCupom">
        </VarejoEmissaoCupom>
      </transition>

      <transition name="fade">
        <VarejoEmissaoCupom v-if="showEmissaoCupomVmov && vmovcaixa && vmovcaixa.codvmovcaixa"
          :index="vmovcaixa.codvmovcaixa" tipo="movimentocaixa" @resultadoemissaocupom="handleResultadoEmissaoCupom">
        </VarejoEmissaoCupom>
      </transition>

      <div v-if="showModalEditItem">
        <VarejoModalItemSequencia :value="editItemValue" @closeModal="closeModalEditItem()" @updateMode="
  editItemValue = $event;
handleEditItem(editItemValue);
        " @confirmedPass="
  pedvit_update = $event;
confirmaItemCancel();
        " :pedvit="pedvit" :pedv="pedv" :modalCrud="modalCrud" :pedvit_update="pedvit_update" />
      </div>

      <!-- FIM FORMULARIO PRINCIPAL DA VENDA -->

      <!-- DESCONTOS -->
      <div v-if="showTotal" class="dropdown-total col-md-4 col-10" style="padding: 15px">
        <button type="button" class="close" @click="showTotal = false">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row col nb-margin-bottom"></div>
      </div>

      <!-- OPCOES BOTAO ENGRENAGEM -->
      <transition name="fade" appear>
        <varejo-modal-opcoes v-if="showModalMaisAcoes" ref="modalOpcoes" :bgButton="hasBgButtomconfig()"
          @selected="handleSelectedOption" @close="showModalMaisAcoes = false">
        </varejo-modal-opcoes>
      </transition>

      <!-- MENSAGEM PARA CANCELAR PEDIDO -->
      <md-message v-if="CANCEL_MESSAGE" :adminPass="true" kind="delete" title="Descartar Venda"
        message="Deseja realmente descartar a venda?" help="" @close="handleCloseMessage()"
        @confirm="handleCancelarVenda()">
      </md-message>


      <div v-if="showModalnfce">
        <VarejoModalNfce ref="modalnfce" @closeModal="showModalnfce = false" />
      </div>

    </div>
  </div>
</template>

<style>
.to-front {
  z-index: 10001;
}

.blank-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  transition: background-color 200ms ease 0s;
  border: none;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 11rem;
}

.blank-button:hover {
  background-color: #eeeeee;
}

.clock {
  width: 4rem;
  text-align: end !important;
}

.item-img {
  border: 1px solid #c9d3dd;
  opacity: 85%;
  border-radius: 5px;
}

.img-size {
  width: 30vw;
  min-height: 285px;
}

.img-size-big {
  width: 100%;
  min-height: 290px;
}

.items-box {
  height: 60vh;
  border-radius: 5px;
  border: 1px solid #c9d3dd;
  overflow-y: scroll;
}

@media (min-width: 1367px) {
  .blank-button {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: none;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 17.5rem;
  }

  .navbar-collapse {
    margin-right: 10px;
  }

  .img-size {
    width: 30vw;
    min-height: 350px;
  }

  .img-size-big {
    width: 47vw;
    min-height: 360px;
  }

  .items-box {
    height: 75vh;
  }
}

.text-button {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 12.5px;
  letter-spacing: -0.025rem;
  color: #004a89;
}

input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.badge-mesa-st {
  width: 15px !important;
  height: 15px !important;
  font-size: 15px;
  display: flex;
  color: #fff;
}

.lista__mesas {
  background: none;
  border: 0;
  padding: 0;
}

.lista__mesas:focus-within {
  border: 1px solid black;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
  {
  opacity: 0;
}

.footer-varejo {
  position: fixed;
  bottom: 0;
  padding: 0px !important;
}

.item-group {
  line-height: 1rem;
}

.register {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 55px;
  width: 150px;
  height: calc(100% - 55px);
  background-color: rgba(15, 43, 73, 0.25);
  display: inherit;
}

.register-info {
  display: block;
  word-break: break-word;
  border-bottom: 1px solid #becbcf;
  padding: 10px;
  background: white;
}

.varejo-button {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* -moz-font-feature-settings: "liga","kern"; */
  position: relative;
  font-family: lato, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  cursor: pointer;
  font-size: 15px;
  border-radius: 3px;
  padding: 12px 20px;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
  min-width: 100px;
  margin: 0 4px;
  border: 1px solid transparent;
  font-weight: 700;
  transition: all 0.2s;
  transition-property: background, color, border;
  outline: none;
}

.varejo-button.varejo-button--primary {
  background-color: #41af4b;
  color: #fff;
}

.varejo-button.varejo-button--big {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* -moz-font-feature-settings: "liga","kern"; */
  line-height: 1.22222;
  font-size: 18px;
  padding: 16px 32px;
}

.varejo-button:last-child {
  margin-right: 0;
}

.varejo-button:first-child {
  margin-left: 0;
}

.varejo-button.varejo-button--primary.disabled,
.varejo-button.varejo-button--primary:disabled,
.varejo-button.varejo-button--primary:disabled:hover,
.varejo-button.varejobutton--primary[disabled] {
  cursor: default;
  pointer-events: none;
  opacity: 0.35;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

.vd-quick-key-label {
  box-sizing: border-box;
  max-width: 100%;
  font-size: 12px;
  line-height: 1.3;
  /* text-align: center; */
  overflow: hidden;
  padding: 4px;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-word;
  text-overflow: ellipsis;
}

.btn--pay {
  width: 100%;
}

.pay-action-value {
  margin-left: auto;
  text-align: right;
  flex-grow: 1;
}

.pay-action-label,
.pay-action-value {
  font-size: 20px;
  font-weight: 700;
}

.footer-shortcuts {
  flex-wrap: wrap;
}

.footer-shortcuts b {
  font-size: 1.1rem;
}

.footer-shortcuts .lbl {
  margin-right: 1rem;
}

.text-wine-color {
  color: #ad2222;
}

.navbar-collapse {
  scrollbar-width: thin;
  scrollbar-color: #c9d3dd transparent;
}

.navbar-collapse::-webkit-scrollbar {
  width: 8px;
}

.navbar-collapse::-webkit-scrollbar-track {
  background: transparent;
}

.vend-inputs {
  text-decoration: none;
  outline: none !important;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.logo-image {
  z-index: -10;
}

.capitalize-text {
  text-transform: capitalize !important;
}

@media (min-width: 1200px) {
  .container-media {
    max-height: 75vh !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-form.vue